import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'
import { SvgProps } from 'react-native-svg'

const Checkboxjfs = (props: SvgProps) => (
  <Svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <Path
      d="M0 4C0 1.79086 1.79086 0 4 0H14C16.2091 0 18 1.79086 18 4V14C18 16.2092 16.2091 18 14 18H4C1.79086 18 0 16.2092 0 14V4Z"
      fill="#CEA15A"
    />
    <G clipPath="url(#clip0_228_5944)">
      <Path
        d="M7.25019 13.0833C7.17342 13.0837 7.09732 13.069 7.02624 13.04C6.95517 13.0109 6.89053 12.9682 6.83602 12.9141L3.91936 9.99745C3.80951 9.8876 3.7478 9.73862 3.7478 9.58328C3.7478 9.42794 3.80951 9.27896 3.91936 9.16911C4.0292 9.05927 4.17818 8.99756 4.33352 8.99756C4.48887 8.99756 4.63785 9.05927 4.74769 9.16911L7.25019 11.6774L13.2527 5.66911C13.3625 5.55927 13.5115 5.49756 13.6669 5.49756C13.8222 5.49756 13.9712 5.55927 14.081 5.66911C14.1909 5.77896 14.2526 5.92794 14.2526 6.08328C14.2526 6.23862 14.1909 6.3876 14.081 6.49745L7.66436 12.9141C7.60985 12.9682 7.54521 13.0109 7.47413 13.04C7.40306 13.069 7.32696 13.0837 7.25019 13.0833Z"
        fill="#0F0D0A"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_228_5944">
        <Rect width={14} height={14} fill="white" transform="translate(2 2)" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Checkboxjfs

